import { render, staticRenderFns } from "./SurveyStatisticsFilter.vue?vue&type=template&id=85b5c132&"
import script from "./SurveyStatisticsFilter.vue?vue&type=script&lang=js&"
export * from "./SurveyStatisticsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports